import * as React from 'react';
import {Component} from 'react';
import Scrollbars from 'react-custom-scrollbars';
import {addNewCond, createNewCond, deleteCond, checkCond} from '../actions/Cond';
import {observer} from 'mobx-react';
import Condition from './Condition';
import {getGeneratorMsg, generatorMessages} from '../../../../constants/TextConst';
import 'rc-tree-select/assets/index.css';

@observer
class ConditionsList extends Component<any, any> {
    forValue;
    ops;
    fieldsToShow;
    reportsToShow;
    scrollbar;

    constructor(props) {
        super(props);
        this.forValue = this.props.forValue;
        this.ops = this.props.ops;
        this.fieldsToShow = this.props.fieldsToShow;
        this.reportsToShow = this.props.reportsToShow;
        this.removeCond = this.removeCond.bind(this);
        this.addCond = this.addCond.bind(this);
        this.checkCondExpr = this.checkCondExpr.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
    }

    removeCond(cond) {
        deleteCond(this.props.field, cond);
    }

    addCond() {
        addNewCond(this.props.field, createNewCond(this.props.field));
        this.scrollToBottom();
    }

    scrollToBottom() {
        if (this.scrollbar) {
            setTimeout(() => {
                this.scrollbar.scrollToBottom();
            }, 0);
        }
    }

    checkCondExpr(cond, idx, handleValidation) {
        checkCond(this.props.field.container, cond, idx, handleValidation);
    }

    getChildData(children) {
        const data: any = [];

        for (const key in children) {
            if (children.hasOwnProperty(key)) {
                const item = children[key];
                data.push({
                    title: item.label,
                    value: item.id + '',
                    key: item.title + key + '',
                    disabled: false
                });
            }
        }

        return data;
    }

    // TODO: we use this from several files, maybe add extern service for getData
    getData() {
        const {reportsToShow} = this.props;
        const listData: any = [];

        for (const key in reportsToShow) {
            if (reportsToShow.hasOwnProperty(key)) {
                const item = reportsToShow[key];

                listData.push({
                    title: item.label,
                    value: item.id + '',
                    key: key,
                    disabled: true,
                    children: this.getChildData(item.children)
                });
            }
        }

        return listData;
    }

    render() {
        const {forValue, ops, fieldsToShow, reportsToShow, sysBasicLang, sysCurrLang} = this.props;

        return (
            <div className="condition-panel-area">
                <span>{getGeneratorMsg(generatorMessages.conditionPanelTitleText)}</span>
                <div className={`list-conditions`}>
                    <Scrollbars
                        ref={s => (this.scrollbar = s)}
                        autoHide
                        className={`scroll-area`}
                        renderThumbVertical={props => <div {...props} className="thumb-vertical" />}
                        autoHeight
                        autoHeightMin={100}
                        autoHeightMax={180}
                    >
                        {this.props.field.conds.map((cond, idx) => {
                            return (
                                <Condition
                                    key={idx}
                                    cond={cond}
                                    forValue={forValue}
                                    ops={ops}
                                    fieldsToShow={fieldsToShow}
                                    reportsToShow={reportsToShow}
                                    checkCondExpr={this.checkCondExpr}
                                    addCond={
                                        idx === this.props.field.conds.length - 1
                                            ? this.addCond
                                            : undefined
                                    }
                                    removeCond={this.removeCond}
                                    sysBasicLang={sysBasicLang}
                                    sysCurrLang={sysCurrLang}
                                />
                            );
                        })}
                    </Scrollbars>
                </div>
            </div>
        );
    }
}

export default ConditionsList;
